import React from 'react'
import { ICharacterItem } from '../../../../../../../../../../api/types/character'
import { ActionIconButton } from '../../../../../../../../../../components/ActionIconButton/ActionIconButton'
import { Tooltip } from '@mui/material'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import { useInvalidatingMutation } from '../../../../../../../../../../hooks/useInvalidatingMutation'
import { AxiosResponse } from 'axios'
import { mutationCreateAction } from '../../../../../../../../../../api/mutations'
import { characterInventoryQueryKey } from '../../../../../../../../../../api/queries'
import { ICreateAction } from '../../../../../../../../../../api/types/action'
import { ConfirmationDialog } from '../../../../../../../../../../components/ConfirmationDialog/ConfirmationDialog'

export const CharacterItemIdentifyAction: React.FC<{
  character_item: ICharacterItem
  game_id: number
}> = ({ character_item, game_id }) => {
  const { mutate: handleIdentifyItem, isLoading } = useInvalidatingMutation<
    AxiosResponse,
    ICreateAction
  >(
    action => mutationCreateAction(action),
    [characterInventoryQueryKey(character_item.character_id)]
  )

  return (
    <>
      {character_item.identified || (
        <ConfirmationDialog
          body={
            <div>
              {'Zgłosić akcję identyfikacji przedmiotu '}
              <strong>{character_item.item.name}</strong>
              {'?'}
            </div>
          }
        >
          {(confirm: any) => (
            <ActionIconButton disabled={isLoading}>
              <Tooltip
                title="Identyfikuj"
                onClick={confirm(
                  (e: any) => () =>
                    new Promise(r => {
                      handleIdentifyItem({
                        game_id: game_id,
                        character_id: character_item.character_id,
                        action_type: 'identify_item',
                        params: JSON.stringify({
                          name: character_item.item.name,
                          id: character_item.id,
                        }),
                      })
                      return r('ok')
                    })
                )}
              >
                <AutoFixHighIcon />
              </Tooltip>
            </ActionIconButton>
          )}
        </ConfirmationDialog>
      )}
    </>
  )
}
